import {useState} from "react";

export default function useToggle(value) {
  const [state, setState] = useState(Boolean(value) || false);
  const toggleState = () => setState(!state);

  return [state, toggleState];
}
